var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            },
            keydown: function($event) {
              _vm.clearError($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Vendor Name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.name,
                        expression: "vendor.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "name" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Name On Check")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.nameOnCheck,
                        expression: "vendor.nameOnCheck"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.nameOnCheck },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "nameOnCheck", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "nameOnCheck" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Company Name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.companyName,
                        expression: "vendor.companyName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.companyName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "companyName", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "companyName" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Short Name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.shortName,
                        expression: "vendor.shortName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.shortName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "shortName", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "shortName" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Address")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.address1,
                        expression: "vendor.address1"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.address1 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "address1", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "address1" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("City")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.addressCity,
                        expression: "vendor.addressCity"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.addressCity },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "addressCity", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "addressCity" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("State")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.states,
                        placeholder: "Select State",
                        autocomplete: "no"
                      },
                      model: {
                        value: _vm.vendor.addressState,
                        callback: function($$v) {
                          _vm.$set(_vm.vendor, "addressState", $$v)
                        },
                        expression: "vendor.addressState"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "addressState" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("ZIP Code")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.addressZip,
                        expression: "vendor.addressZip"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.addressZip },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "addressZip", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "addressZip" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Address 2")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.address2,
                        expression: "vendor.address2"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.address2 },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "address2", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "address2" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Account number")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.accNumber,
                        expression: "vendor.accNumber"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.accNumber },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "accNumber", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "accNumber" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Tax ID")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.vendor.taxId,
                        expression: "vendor.taxId"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.vendor.taxId },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.vendor, "taxId", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "taxId" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Tax ID Type")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        placeholder: "Select",
                        options: _vm.taxIdTypes,
                        "hide-select": true
                      },
                      model: {
                        value: _vm.vendor.taxIdType,
                        callback: function($$v) {
                          _vm.$set(_vm.vendor, "taxIdType", $$v)
                        },
                        expression: "vendor.taxIdType"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "taxIdType" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.company.company_billing
            ? _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "check-field" }, [
                    _c(
                      "label",
                      {
                        class: [
                          _vm.vendor.sendRequest ? "check-open" : "check-closed"
                        ],
                        attrs: { for: "send-request" }
                      },
                      [
                        _c("span", { staticClass: "checkmark" }),
                        _vm._v(
                          "\n              Also send me an invitation to join Bill.com and receive electronic payments\n              "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.vendor.sendRequest,
                              expression: "vendor.sendRequest"
                            }
                          ],
                          staticClass: "btn-check",
                          attrs: {
                            type: "checkbox",
                            value: "1",
                            id: "send-request"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.vendor.sendRequest)
                              ? _vm._i(_vm.vendor.sendRequest, "1") > -1
                              : _vm.vendor.sendRequest
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.vendor.sendRequest,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.vendor,
                                      "sendRequest",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.vendor,
                                      "sendRequest",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.vendor, "sendRequest", $$c)
                              }
                            }
                          }
                        })
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.company.company_billing && _vm.vendor.sendRequest
            ? _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", { attrs: { for: "request-email" } }, [
                      _vm._v("Email")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.vendor.requestEmail,
                          expression: "vendor.requestEmail"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "request-email",
                        name: "request-email",
                        type: "text"
                      },
                      domProps: { value: _vm.vendor.requestEmail },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.vendor,
                            "requestEmail",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3 mb-3" }, [
            _c("div", { staticClass: "col text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v("\n            Cancel\n          ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary ld-ext-right",
                  class: _vm.loadingButton ? "running" : "",
                  attrs: { disabled: _vm.buttonDisabled || !_vm.formInvalid }
                },
                [
                  _vm._v("\n            Submit\n            "),
                  _c("div", { staticClass: "ld ld-ball ld-flip" })
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e1adac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e1adac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/mod24settings/Check.vue
// module id = null
// module chunks = 